import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const empty = { nome: '', ano: new Date().getFullYear() };

export default function AdminTemporadas() {
  const [temporadas, setTemporadas] = useState([]);
  const [form, setForm] = useState(empty);
  const [editando, setEditando] = useState(null);
  const [msg, setMsg] = useState('');

  useEffect(() => { carregar(); }, []);
  function carregar() { api.get('/temporadas').then(setTemporadas).catch(() => {}); }

  async function salvar(e) {
    e.preventDefault(); setMsg('');
    try {
      if (editando) { await api.put(`/temporadas/${editando.id}`, { ...form, ativo: editando.ativo }); }
      else { await api.post('/temporadas', form); }
      setMsg('Salvo!'); setForm(empty); setEditando(null); carregar();
    } catch (err) { setMsg(err.message); }
  }

  async function deletar(id) {
    if (!window.confirm('Remover?')) return;
    await api.delete(`/temporadas/${id}`); carregar();
  }

  return (
    <div>
      <h2 className="admin-title">Temporadas</h2>
      {msg && <div className="alert alert-success">{msg}</div>}
      <form onSubmit={salvar} className="admin-form">
        <h3>{editando ? 'Editar' : 'Nova Temporada'}</h3>
        <div className="form-row">
          <div className="form-group"><label>Nome</label><input value={form.nome} onChange={e => setForm({ ...form, nome: e.target.value })} required /></div>
          <div className="form-group"><label>Ano</label><input type="number" value={form.ano} onChange={e => setForm({ ...form, ano: e.target.value })} required /></div>
        </div>
        <div className="admin-actions">
          <button type="submit" className="btn btn-primary">Salvar</button>
          {editando && <button type="button" className="btn btn-secondary" onClick={() => { setEditando(null); setForm(empty); }}>Cancelar</button>}
        </div>
      </form>
      <div className="admin-table-wrap">
        <table>
          <thead><tr><th>Nome</th><th>Ano</th><th>Ativo</th><th>Ações</th></tr></thead>
          <tbody>
            {temporadas.map(t => (
              <tr key={t.id}>
                <td>{t.nome}</td><td>{t.ano}</td>
                <td>{t.ativo ? <span className="badge badge-success">Sim</span> : <span className="badge badge-danger">Não</span>}</td>
                <td>
                  <div className="admin-actions">
                    <button className="btn btn-secondary" onClick={() => { setEditando(t); setForm({ nome: t.nome, ano: t.ano }); }}>Editar</button>
                    <button className="btn btn-danger" onClick={() => deletar(t.id)}>Remover</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
